import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-358f1d5a")

_pushScopeId("data-v-358f1d5a")
const _hoisted_1 = { class: "FtlOrderTemplate" }
const _hoisted_2 = { class: "FtlOrderTemplate__type" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "type__title" }, "Выберите тип доставки", -1)
const _hoisted_4 = { class: "type__content" }
const _hoisted_5 = { class: "FtlOrderTemplate__create" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Создать заказ ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" В мои заказы ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_send_date_time_period = _resolveComponent("send-date-time-period")!
  const _component_completed_date = _resolveComponent("completed-date")!
  const _component_cargo_characteristics = _resolveComponent("cargo-characteristics")!
  const _component_new_waypoints_form = _resolveComponent("new-waypoints-form")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_multiselect, {
          modelValue: _ctx.state.ftl_type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.ftl_type = $event)),
          options: _ctx.FTL_TYPES,
          disabled: _ctx.progress.is_loading || _ctx.progress.is_created,
          label: "name",
          trackBy: "name",
          placeholder: "Тип",
          searchable: "",
          noResultsText: "Ничего не найдено",
          noOptionsText: "Список пуст",
          canDeselect: false,
          onChange: _ctx.onTypeChange
        }, null, 8, ["modelValue", "options", "disabled", "onChange"])
      ])
    ]),
    (!_ctx.state.take_date && !_ctx.state.take_time)
      ? (_openBlock(), _createBlock(_component_send_date_time_period, {
          key: 0,
          isFTL: true,
          opened: true,
          onConfirm: _ctx.setDateAndTime
        }, null, 8, ["onConfirm"]))
      : (_openBlock(), _createBlock(_component_completed_date, {
          key: 1,
          "take-date": _ctx.state.take_date,
          "take-time": _ctx.state.take_time,
          disabled: _ctx.progress.is_loading || _ctx.progress.is_created,
          onReset: _ctx.resetDateAndTime
        }, null, 8, ["take-date", "take-time", "disabled", "onReset"])),
    _createVNode(_component_cargo_characteristics, {
      opened: Boolean(_ctx.state.take_date) && Boolean(_ctx.state.take_time),
      completed: _ctx.progress.is_cargo_setted,
      disabled: _ctx.progress.is_loading || _ctx.progress.is_created,
      "is-not-required": _ctx.state.ftl_type === 0 || _ctx.state.ftl_type === 2,
      "ftl-type": _ctx.state.ftl_type,
      onConfirm: _ctx.setCharacteristics,
      onReset: _ctx.resetCharacteristics
    }, null, 8, ["opened", "completed", "disabled", "is-not-required", "ftl-type", "onConfirm", "onReset"]),
    _createVNode(_component_new_waypoints_form, {
      opened: _ctx.progress.is_cargo_setted,
      "ftl-type": _ctx.state.ftl_type,
      disabled: _ctx.progress.is_loading || _ctx.progress.is_created,
      completed: _ctx.progress.is_waypoints_completed,
      onEdit: _ctx.openWaypoints,
      onSubmit: _ctx.setWaypoints
    }, null, 8, ["opened", "ftl-type", "disabled", "completed", "onEdit", "onSubmit"]),
    _createVNode("div", _hoisted_5, [
      (_ctx.progress.is_waypoints_completed && !_ctx.progress.is_created)
        ? (_openBlock(), _createBlock(_component_s_button, {
            key: 0,
            loading: _ctx.progress.is_loading,
            class: "red",
            onClick: _ctx.createOrder
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.progress.is_created)
        ? (_openBlock(), _createBlock(_component_s_button, {
            key: 1,
            class: "red",
            onClick: _ctx.goToHistory
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
})